<template>
  <div v-if="order">
    <v-card
      flat
    >
      <v-card-title>
        <span style="color: #0074BA">回収日</span>&emsp;
        <v-btn
          v-if="canShowEditButton"
          small
          @click="collectDialogButtonClickEvent"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
          &nbsp;編集
        </v-btn>

      </v-card-title>
      <v-card-text>
        <!-- 回収日／希望時間 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              回収日
            </div>
            <h4>{{ order.collected_date | date_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              希望時間
            </div>
            <h4>
              <span v-if="order.preferred_start_time || order.preferred_end_time">
                {{ order.preferred_start_time | from_to_linked_time(order.preferred_end_time, ' 〜 ') }}&nbsp;
              </span>
              &nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /回収日／希望時間 -->

      </v-card-text>
    </v-card>
    <edit-collect-dialog
      :order-id="order.id"
      :enable-dialog="enableCollectDialog"
      @closeCallback="collectDialogCloseDialog"
      @registerCallback="collectDialogRegisterCallBack"
    />
  </div>
</template>
<script>

import EditCollectDialog from '../dialogs/_EditCollectDialog'

export default {
  name: 'ManifestCollectBlock',
  components: {
    EditCollectDialog,
  },
  mixins: [],
  props: {
    /**
     * @typedef order { Object }
     * @property id { Number }
     * @property collect { Object }
     */
    order: {
      type: Object,
      default: () => {},
    },
    canShowEditButton: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      enableCollectDialog: false,
    }
  },
  computed: {},
  created() {
  },
  methods: {
    /**
     * 回収日 編集するボタン クリックイベント
     */
    collectDialogButtonClickEvent () {
      this.enableCollectDialog = true
    },
    /**
     * 回収日編集ダイアログ キャンセルコールバック処理
     */
    collectDialogCloseDialog () {
      this.enableCollectDialog = false
    },
    /**
     * 回収日編集ダイアログ 登録コールバック処理
     */
    collectDialogRegisterCallBack () {
      this.$emit('refreshDetail')
      this.collectDialogCloseDialog()
    },
  }

}
</script>

<style scoped>

</style>
